<template>
  <div class="page">
    <h1>OCR</h1>
  </div>
</template>
